import React from "react";

import defaultImage from 'assets/img/no_profile.png';

class PictureUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: props.preview || defaultImage
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });

      if(this.props.onImagePicked) {
        this.props.onImagePicked(file);
      }
    };
    if(file) {
      reader.readAsDataURL(file);
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  render() {
    return (
      <div className="picture-container">
        <div className="picture" style={this.props.style}>
          <img
            src={this.state.imagePreviewUrl}
            className="picture-src"
            alt="..."
            style={this.props.imgStyle}
          />
          <input type="file" onChange={e => this.handleImageChange(e)} />
        </div>
        {/* <h6 className="description">Choose Picture</h6> */}
      </div>
    );
  }
}

export default PictureUpload;
